// extracted by mini-css-extract-plugin
export var activeDot = "_2m-c";
export var buttonContainer = "_2m-9";
export var channelButton = "_2m-a";
export var clickable = "_2m-d";
export var content = "_2m-0";
export var contentFull = "_2m-2";
export var contentThird = "_2m-1";
export var contentWrapper = "_2m-7";
export var description = "_2m-5";
export var heightShort = "_2m-f";
export var image = "_2m-3";
export var imageContainer = "_2m-4";
export var selectButton = "_2m-e";
export var spinnerContainer = "_2m-b";
export var titleContent = "_2m-8";
export var titleWrapper = "_2m-6";